'use client';

import type { ConfigProps } from '@highereducation/wordpress';
import { useState } from 'react';
import { env } from '../env';

export default function Debug({
  tenant,
  path,
  postData,
  config,
}: {
  tenant: string;
  path: string;
  postData: any;
  config: ConfigProps;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [viewMode, setViewMode] = useState<'config' | 'postData' | 'env'>(
    'config',
  );

  let dataToDisplay: string;

  switch (viewMode) {
    case 'config':
      dataToDisplay = JSON.stringify(config, null, 2);
      break;
    case 'postData':
      dataToDisplay = JSON.stringify(postData, null, 2);
      break;
    case 'env':
      dataToDisplay = JSON.stringify(env, null, 2);
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1e1e1e',
        color: '#d4d4d4',
        borderTop: '2px solid #007acc',
        zIndex: 9999,
        transition: 'max-height 0.3s ease',
        maxHeight: isExpanded ? '80vh' : '40px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px',
          gap: '10px',
        }}
      >
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            flex: 1,
            padding: 0,
            backgroundColor: 'transparent',
            color: '#007acc',
            border: 'none',
            cursor: 'pointer',
            textAlign: 'left',
            fontWeight: 'bold',
            fontSize: '14px',
          }}
        >
          <span style={{ marginRight: '10px', color: '#888' }}>
            tenant: {tenant} | path: {path}
          </span>
          {isExpanded ? '▼' : '▶'} Debug Config
        </button>
        {isExpanded && (
          <div style={{ display: 'flex', gap: '5px' }}>
            <button
              onClick={() => setViewMode('config')}
              style={{
                padding: '5px 10px',
                backgroundColor:
                  viewMode === 'config' ? '#007acc' : 'transparent',
                color: viewMode === 'config' ? '#fff' : '#007acc',
                border: '1px solid #007acc',
                borderRadius: '3px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
            >
              Config
            </button>
            <button
              onClick={() => setViewMode('postData')}
              style={{
                padding: '5px 10px',
                backgroundColor:
                  viewMode === 'postData' ? '#007acc' : 'transparent',
                color: viewMode === 'postData' ? '#fff' : '#007acc',
                border: '1px solid #007acc',
                borderRadius: '3px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
            >
              Post Data
            </button>
            <button
              onClick={() => setViewMode('env')}
              style={{
                padding: '5px 10px',
                backgroundColor: viewMode === 'env' ? '#007acc' : 'transparent',
                color: viewMode === 'env' ? '#fff' : '#007acc',
                border: '1px solid #007acc',
                borderRadius: '3px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
            >
              Env
            </button>
          </div>
        )}
      </div>
      {isExpanded && (
        <div
          style={{
            padding: '10px',
            maxHeight: 'calc(80vh - 60px)',
            overflow: 'auto',
          }}
        >
          <pre style={{ margin: 0, fontSize: '12px' }}>{dataToDisplay}</pre>
        </div>
      )}
    </div>
  );
}
